import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/Acerca.css";

const Acerca = () => {
  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="acerca-hero-section">
        <div className="acerca-hero-content">
          <div className="acerca-hero-container">
            <div className="acerca-hero-card">
              <div className="acerca-hero-grid">
                <div className="acerca-hero-left">
                  <h1 className="acerca-hero-title">
                    Conoce más sobre la
                    <span className="acerca-hero-title-gradient"> RESNOM</span>
                  </h1>
                </div>
                <div className="noticias-hero-right">
                  <h2 className="acerca-hero-subtitle">Red Sísmica del CICESE</h2>
                  <p className="acerca-hero-description">
                    La red tiene una historia que le ha dado forma a lo que es hoy. En esta sección conocerás un poco
                    más sobre su historia, objetivos y colaboraciones importantes con otras instituciones.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Historia Section */}
      <section className="acerca-historia-section">
        <div className="acerca-historia-container">
          <div className="acerca-historia-content">
            <div className="acerca-historia-text">
              <h2 className="acerca-historia-title">
                Historia de las Redes Sísmicas del
                <span className="acerca-historia-title-gradient"> CICESE</span>
              </h2>
              <p className="acerca-historia-subtitle">Como se conforma nuestra infraestructura</p>
              <p className="acerca-historia-description">
                El CICESE ha operado diversas redes sísmicas durante más de tres décadas y estas redes forman parte
                importante de la infraestructura del Departamento de Sismología del CICESE. En el año 2015, la Red
                Sísmica del Noroeste de México (RESNOM), la Red de Acelerógrafos del Noroeste de México (RANM), la Red
                Sismológica de Banda Ancha del Golfo de California (RESBAN), la Red Urbana de Baja California (RAUBC) y
                la Red Sismológica de La Paz (RSLP), se unen para conformar una sola red denominada{" "}
                <strong>Red Sísmica del CICESE.</strong>
              </p>
            </div>
            <div className="acerca-historia-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/acerca-obj-2.jpeg`} alt="Objetivos RESNOM" />
            </div>
          </div>
        </div>
      </section>

      {/* Objetivos Section */}
      <section className="acerca-objetivos-section">
        <div className="acerca-objetivos-container">
          <div className="acerca-objetivos-header">
            <h2 className="acerca-objetivos-title">
              Objetivos de la
              <span className="acerca-objetivos-title-gradient"> RESNOM</span>
            </h2>
            <p className="acerca-objetivos-subtitle">Nuestros objetivos fundamentales son:</p>
          </div>

          <div className="acerca-objetivos-grid">
            <div className="acerca-objetivo-card">
              <div className="acerca-objetivo-icon">
                <i className="fas fa-wave-square"></i>
              </div>
              <div className="acerca-objetivo-content">
                <h3 className="acerca-objetivo-title">Detección y Registro</h3>
                <p className="acerca-objetivo-description">
                  Detectar, registrar, catalogar e intercambiar información sobre la sismicidad que ocurre en el
                  noroeste de México.
                </p>
              </div>
            </div>

            <div className="acerca-objetivo-card">
              <div className="acerca-objetivo-icon">
                <i className="fas fa-database"></i>
              </div>
              <div className="acerca-objetivo-content">
                <h3 className="acerca-objetivo-title">Fuente de Datos Confiable</h3>
                <p className="acerca-objetivo-description">
                  Ser una fuente de datos confiable, que permita estudiar y entender las características de la
                  sismicidad de la región. Estos datos están disponibles para la comunidad académica (investigadores y
                  estudiantes) que lo soliciten.
                </p>
              </div>
            </div>

            <div className="acerca-objetivo-card">
              <div className="acerca-objetivo-icon">
                <i className="fas fa-info-circle"></i>
              </div>
              <div className="acerca-objetivo-content">
                <h3 className="acerca-objetivo-title">Servicio a la Sociedad</h3>
                <p className="acerca-objetivo-description">
                  Proporcionar un servicio de información veraz y oportuna a la sociedad, medios de comunicación y a
                  autoridades relacionadas con protección civil. La información proporcionada es sobre la actividad
                  sísmica (localizaciones, magnitudes y mapas de intensidades) que ocurre en la región noroeste de
                  México.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Instituciones Section */}
      <section className="acerca-institutions-section">
        <div className="acerca-institutions-container">
          <div className="acerca-institutions-header">
            <h2 className="acerca-institutions-title">
              Instituciones y <span className="acerca-institutions-title-gradient">Colaboradores</span>
            </h2>
            <p className="acerca-institutions-description">
              La Red Sísmica del Noroeste de México está conformada por una infraestructura de estaciones sísmicas de
              banda ancha y acelerométricas, las cuales registran continuamente la actividad sísmica en la región
              noroeste de México. Además, la RESNOM mantiene una colaboración activa con diversas instituciones
              nacionales e internacionales, lo que permite el intercambio de datos en tiempo real, la estandarización de
              metodologías de análisis y el desarrollo de proyectos conjuntos orientados a la mejora del monitoreo
              sísmico.
            </p>
          </div>

          {/* Instituciones Principales */}
          <div className="acerca-institutions-main">
            <div className="acerca-institutions-sidebar">
              <h3>Instituciones</h3>
              <p>Institutos y centros de investigación con los que se intercambian datos en tiempo real.</p>
            </div>
            <div className="acerca-institutions-grid">
              <div className="acerca-institution-card">
                <a href="http://www.ssn.unam.mx/" target="_blank" rel="noopener noreferrer">
                  <div className="acerca-institution-image">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/ssn_logo.jpg`} alt="SSN Logo" />
                  </div>
                  <div className="acerca-institution-info">
                    <h4>SSN</h4>
                    <p>Servicio Sismológico Nacional</p>
                  </div>
                </a>
              </div>

              <div className="acerca-institution-card">
                <a href="https://www.usgs.gov/programs/earthquake-hazards" target="_blank" rel="noopener noreferrer">
                  <div className="acerca-institution-image">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/usgs_logo.jpg`} alt="USGS Logo" />
                  </div>
                  <div className="acerca-institution-info">
                    <h4>USGS</h4>
                    <p>Servicio Geológico de Estados Unidos</p>
                  </div>
                </a>
              </div>

              <div className="acerca-institution-card">
                <a href="https://scedc.caltech.edu/" target="_blank" rel="noopener noreferrer">
                  <div className="acerca-institution-image">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/scedc_logo.jpg`} alt="SCEDC Logo" />
                  </div>
                  <div className="acerca-institution-info">
                    <h4>SCEDC</h4>
                    <p>Southern California Earthquake Data Center</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Colaboraciones */}
          <div className="acerca-collaborations">
            <div className="acerca-collaborations-sidebar">
              <h3>Colaboraciones y sitios de interés</h3>
              <p>La RESNOM colabora y comparte información con las siguientes instituciones.</p>
            </div>
            <div className="acerca-collaborations-carousel">
              <Slider
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={3}
                slidesToScroll={1}
                autoplay={true}
                autoplaySpeed={3000}
                responsive={[
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    },
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    },
                  },
                ]}
              >
                <div className="acerca-collaboration-slide">
                  <a href="https://www.isc.ac.uk/" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/isc.png`} alt="ISC Logo" />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>ISC</h4>
                      <p>International Seismological Centre</p>
                    </div>
                  </a>
                </div>

                <div className="acerca-collaboration-slide">
                  <a href="https://www.earthscope.org/" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/images-networks/EarthScope_Consortium_logo.png`}
                        alt="Earthscope Logo"
                      />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>EarthScope</h4>
                      <p>EarthScope Consortium</p>
                    </div>
                  </a>
                </div>

                <div className="acerca-collaboration-slide">
                  <a href="https://www.gob.mx/cenapred" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/images-networks/cenapred_logo.jpg`}
                        alt="CENAPRED Logo"
                      />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>CENAPRED</h4>
                      <p>Centro Nacional de Prevención de Desastres</p>
                    </div>
                  </a>
                </div>

                <div className="acerca-collaboration-slide">
                  <a href="https://secihti.mx/" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/images-networks/secihti.png`}
                        alt="SECIHTI Logo"
                      />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>SECIHTI</h4>
                      <p>Secretaría de Humanidades, Tecnología e Innovación</p>
                    </div>
                  </a>
                </div>

                <div className="acerca-collaboration-slide">
                  <a href="https://www.noaa.gov/" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/noaa_logo.jpg`} alt="NOAA Logo" />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>NOAA</h4>
                      <p>National Oceanic and Atmospheric Administration</p>
                    </div>
                  </a>
                </div>

                <div className="acerca-collaboration-slide">
                  <a href="https://sopac-csrc.ucsd.edu/" target="_blank" rel="noopener noreferrer">
                    <div className="acerca-collaboration-image">
                      <img src={`${process.env.PUBLIC_URL}/assets/img/images-networks/sopac.jpg`} alt="SOPAC Logo" />
                    </div>
                    <div className="acerca-collaboration-info">
                      <h4>SOPAC</h4>
                      <p>Scripps Orbit and Permanent Array Center</p>
                    </div>
                  </a>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>

      {/* Agradecimientos Section */}
      <section className="acerca-acknowledgments-section">
        <div className="acerca-acknowledgments-container">
          <div className="acerca-acknowledgments-content">
            <div className="acerca-acknowledgments-text">
              <h3 className="acerca-acknowledgments-title">Agradecimientos</h3>
              <p className="acerca-acknowledgments-description">
                A través de los años, el CICESE y el Consejo Nacional de Ciencia y Tecnología (CONACyT), ahora
                Secretaría de Humanidades, Tecnología e Innovación (SECIHTI), han proporcionado los fondos necesarios
                para hacer posible la instalación, operación y mantenimiento de las estaciones de la Red Sísmica del
                CICESE.
              </p>
            </div>
            <div className="acerca-acknowledgments-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/Logo-SECIHTI-1.jpg`} alt="Logo SECIHTI" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Acerca;
